import c0 from './add_button_controller';
import c1 from './add_to_queue_controller';
import c2 from './blocks/episodes/media_progress_controller';
import c3 from './blocks/episodes/season_chips_controller';
import c4 from './blocks/episodes/season_hero_resume_controller';
import c5 from './blocks/layout/tab_bar_component_controller';
import c6 from './blocks/live_streams/banner_component_controller';
import c7 from './blocks/live_streams/chat_tip_controller';
import c8 from './blocks/live_streams/editorial_info_panel_component_controller';
import c9 from './blocks/live_streams/pinned_tips_controller';
import c10 from './blocks/newsletters/choices_controller';
import c11 from './blocks/newsletters/resend_feedback_controller';
import c12 from './bridge/notification_controller';
import c13 from './button_controller';
import c14 from './chat_panel_controller';
import c15 from './connect_link_controller';
import c16 from './live_poll_controller';
import c17 from './notification_controller';
import c18 from './poll_interaction_controller';
import c19 from './queue_button_controller';
import c20 from './referral_source_controller';
import c21 from './shareable_link_controller';
import c22 from './thumbnail_controller';
import c23 from './vote_controller';
export const definitions = [
	{identifier: 'add-button', controllerConstructor: c0},
	{identifier: 'add-to-queue', controllerConstructor: c1},
	{identifier: 'blocks--episodes--media-progress', controllerConstructor: c2},
	{identifier: 'blocks--episodes--season-chips', controllerConstructor: c3},
	{identifier: 'blocks--episodes--season-hero-resume', controllerConstructor: c4},
	{identifier: 'blocks--layout--tab-bar-component', controllerConstructor: c5},
	{identifier: 'blocks--live-streams--banner-component', controllerConstructor: c6},
	{identifier: 'blocks--live-streams--chat-tip', controllerConstructor: c7},
	{identifier: 'blocks--live-streams--editorial-info-panel-component', controllerConstructor: c8},
	{identifier: 'blocks--live-streams--pinned-tips', controllerConstructor: c9},
	{identifier: 'blocks--newsletters--choices', controllerConstructor: c10},
	{identifier: 'blocks--newsletters--resend-feedback', controllerConstructor: c11},
	{identifier: 'bridge--notification', controllerConstructor: c12},
	{identifier: 'button', controllerConstructor: c13},
	{identifier: 'chat-panel', controllerConstructor: c14},
	{identifier: 'connect-link', controllerConstructor: c15},
	{identifier: 'live-poll', controllerConstructor: c16},
	{identifier: 'notification', controllerConstructor: c17},
	{identifier: 'poll-interaction', controllerConstructor: c18},
	{identifier: 'queue-button', controllerConstructor: c19},
	{identifier: 'referral-source', controllerConstructor: c20},
	{identifier: 'shareable-link', controllerConstructor: c21},
	{identifier: 'thumbnail', controllerConstructor: c22},
	{identifier: 'vote', controllerConstructor: c23},
];
